// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"93":"94f0af17","94":"83660fa3","190":"5182fde1","389":"00c91712","443":"477b62cf","606":"3d85bb6a","692":"c156b598","763":"e008ed57","884":"ea745feb","895":"d45e9622"}[chunkId] + ".chunk.js";
};